import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-package-modal-body" }
const _hoisted_2 = { class: "modal-bar" }
const _hoisted_3 = { class: "actions" }

import { reactive, ref } from "vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";
import AppTextArea from "@/shared/components/ui/AppTextArea.vue";
import { useModalStore } from "@/shared/stores/modal";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";

type SchedulePackage = {
  id?: number | string;
  name: string;
  highlight: string;
  features: string;
  price: number | string;
  package_type: "one_time";
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AddSchedulePackageModal',
  props: {
    onAdd: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const modal = useModalStore();

const schedule_package = reactive<SchedulePackage>({
  name: "",
  highlight: "",
  features: "",
  price: "",
  package_type: "one_time",
});

// Error messages for validation
const nameError = ref("");
const highlightError = ref("");
const featuresError = ref("");
const pricingError = ref("");

function slugify(input: string) {
  return input
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

function generateId() {
  const base = slugify(schedule_package.name) || "package";
  return `${base}_${Date.now()}`;
}

function handleSubmit() {
  // Clear previous errors
  nameError.value = "";
  highlightError.value = "";
  featuresError.value = "";
  pricingError.value = "";

  const pkgName = schedule_package.name.trim();
  if (!pkgName) {
    nameError.value = "Package name is required";
    return;
  }

  const pkgHighlight = schedule_package.highlight.trim();
  if (!pkgHighlight) {
    highlightError.value = "Package highlight is required";
    return;
  }

  const pkgFeatures = schedule_package.features.trim();
  if (!pkgFeatures) {
    featuresError.value = "Package features are required";
    return;
  }

  const numericPrice = schedule_package.price === "" ? null : Number(schedule_package.price);
  if (numericPrice === null || Number.isNaN(numericPrice) || numericPrice <= 0) {
    pricingError.value = "Fixed price is required and must be greater than 0.";
    return;
  }

  const pkg: SchedulePackage = {
    name: pkgName,
    highlight: pkgHighlight,
    features: pkgFeatures,
    price: numericPrice,
    package_type: "one_time",
  };

  props.onAdd?.(pkg);

  modal.close();
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_toolbar, {
      class: "modal-toolbar",
      density: "comfortable",
      flat: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            class: "back-btn",
            "aria-label": "Back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modal).close()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("mdi-arrow-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal-title" }, "Add package", -1))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_text, { class: "body py-6" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          class: "form",
          onSubmit: _withModifiers(handleSubmit, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(AppTextField, {
              modelValue: schedule_package.name,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((schedule_package.name) = $event)),
                _cache[2] || (_cache[2] = ($event: any) => (nameError.value = ''))
              ],
              label: "Package name",
              placeholder: "e.g., Basic Pest Control",
              "error-messages": nameError.value
            }, null, 8, ["modelValue", "error-messages"]),
            _createVNode(AppTextArea, {
              modelValue: schedule_package.highlight,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((schedule_package.highlight) = $event)),
                _cache[4] || (_cache[4] = ($event: any) => (highlightError.value = ''))
              ],
              label: "Highlight",
              placeholder: "e.g., Exterior treatment + monthly follow-up",
              rows: "3",
              "error-messages": highlightError.value
            }, null, 8, ["modelValue", "error-messages"]),
            _createVNode(AppTextArea, {
              modelValue: schedule_package.features,
              "onUpdate:modelValue": [
                _cache[5] || (_cache[5] = ($event: any) => ((schedule_package.features) = $event)),
                _cache[6] || (_cache[6] = ($event: any) => (featuresError.value = ''))
              ],
              label: "Features",
              placeholder: "e.g., Spray, Inspection, Warranty",
              hint: "Enter features separated by commas..",
              rows: "4",
              "error-messages": featuresError.value
            }, null, 8, ["modelValue", "error-messages"]),
            _createVNode(AppTextField, {
              modelValue: schedule_package.price,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((schedule_package.price) = $event)),
                _cache[8] || (_cache[8] = ($event: any) => (pricingError.value = ''))
              ],
              label: "Price",
              type: "number",
              placeholder: "0.00",
              "prepend-inner-icon": "mdi-currency-usd",
              "hide-details": "",
              "error-messages": pricingError.value
            }, null, 8, ["modelValue", "error-messages"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(AppButtonFlat, {
                block: "",
                onClick: handleSubmit,
                "prepend-icon": "mdi-check",
                color: "primary"
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode(" Create ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})